/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ChangeReportsOwnersQuery model module.
 * @module model/ChangeReportsOwnersQuery
 * @version 0.0.1
 */
class ChangeReportsOwnersQuery {
    /**
     * Constructs a new <code>ChangeReportsOwnersQuery</code>.
     * @alias module:model/ChangeReportsOwnersQuery
     */
    constructor() { 
        
        ChangeReportsOwnersQuery.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ChangeReportsOwnersQuery</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ChangeReportsOwnersQuery} obj Optional instance to populate.
     * @return {module:model/ChangeReportsOwnersQuery} The populated <code>ChangeReportsOwnersQuery</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ChangeReportsOwnersQuery();

            if (data.hasOwnProperty('reportIds')) {
                obj['reportIds'] = ApiClient.convertToType(data['reportIds'], ['String']);
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ChangeReportsOwnersQuery</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ChangeReportsOwnersQuery</code>.
     */
    static validateJSON(data) {
        // ensure the json data is an array
        if (!Array.isArray(data['reportIds'])) {
            throw new Error("Expected the field `reportIds` to be an array in the JSON data but got " + data['reportIds']);
        }
        // ensure the json data is a string
        if (data['userId'] && !(typeof data['userId'] === 'string' || data['userId'] instanceof String)) {
            throw new Error("Expected the field `userId` to be a primitive type in the JSON string but got " + data['userId']);
        }

        return true;
    }


}



/**
 * @member {Array.<String>} reportIds
 */
ChangeReportsOwnersQuery.prototype['reportIds'] = undefined;

/**
 * @member {String} userId
 */
ChangeReportsOwnersQuery.prototype['userId'] = undefined;






export default ChangeReportsOwnersQuery;

